import React, { Component, createRef } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

import i18next from "i18next";

import "../FontAwesome";
import Header from "../components/Header";
import axios from "axios";
import randomIntFromInterval from "../utils/randomIntFromInterval";
import PropTypes from "prop-types";
import DetectFontChange from "../components/DetectFontChange";
import LayoutContent from "../components/LayoutContent";
import Main from "../components/Main";
import Modal from "../components/Modal";
import ModalTeam from "../components/ModalTeam";
import ModalQuestion from "../components/ModalQuestion";
import ModalPassword from "../components/ModalPassword";

import IntroductionScreen from "../components/IntroductionScreen";
import { UserProvider } from "../components/Context";
import {
  minimumSession,
  maximumSession,
  sessionQuestionTimer,
  standardSessionTime
} from "../utils/gameVariable";
import { async } from "regenerator-runtime";
import { Navigate } from "react-router-dom";

const queryClient = new QueryClient();
var usedGlobal = [];
var index = 0;

/**
 * @augments {Component<Game.propTypes>}
 */
class Game extends Component {
  static propTypes = {
    isIframe: PropTypes.bool
  };

  static defaultProps = {
    isIframe: false
  };

  childref = React.createRef();
  anotherChildRef = React.createRef();

  constructor(props) {
    super(props);
    this.handleMountWheelData = this.handleMountWheelData.bind(this);
    this.ModalQuestion = createRef();
    this.state = {
      baseUrl: window.baseUrl,
      exclude: window.exclude,
      logo: window.themes.logo,
      // Hide inside iframe
      isShow_header: !props.isIframe,
      // eslint-disable-next-line no-extra-boolean-cast
      // isOpen_instruction: !Boolean(parseInt(window.backend.set_password)),
      isOpen_instruction: true,
      isOpen_about: false,
      isOpen_embed: false,
      isOpen_question: false,
      isOpen_team: false,
      isUse_password: Boolean(parseInt(window.backend.set_password)),
      isOpen_password: false,
      isNext_instruction: true,
      question: {
        icon_category: null,
        category_name: null,
        member: null,
        post_content: null
      },
      color: null,
      text_color: null,
      categories: window.categories,
      categories_isOpen: true,
      members: [], // TODO: push current game users into members array
      membersInactive: [],
      membersPlayed: [],
      membersPlaying: [],
      wheelTextStyle: null,
      selectedPlayer: "",
      // round progress
      currentRound: 0,
      currentTime: 1,
      totalRound: 1,
      // round states
      totalTimeSelected: standardSessionTime || 30,
      font_heading: window.fonts.heading.regular_font,
      font_body: window.fonts.body.regular_font,
      is_Play: "none",
      is_Playing: false,
      is_Valid: false,
      isActive: false
    };
  }

  handleMountWheelData() {
    this.props.addWheelData(this.state.members);
  }

  componentDidMount() {
    document.addEventListener("keyup", this.handleEscape);

    this.handleMountWheelData();
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleEscape);
  }

  handleEscape = e => {
    if (e.keyCode === 27) {
      this.setState({
        isOpen_about: false,
        isOpen_embed: false
      });
    }
  };

  onChangeTimer = timerValue => {
    this.setState({
      totalTimeSelected: timerValue
    });
  };

  onStart = members => {
    this.setState({
      members: members,
      membersInactive: members,
      membersPlayed: [],
      membersPlaying: [],
      isOpen_team: false,
    });

    const membersInactive = this.state.membersInactive;
    const membersPlayed = this.state.membersPlayed;

    let newMembersPlaying;
    let newMembersPlayed;
    let newMembersInactive;

    if (membersInactive.length > 0) {
      newMembersInactive = [...membersInactive];
      newMembersPlayed = [...membersPlayed];
    } else {
      // Restart
      newMembersInactive = [...membersPlayed];
      newMembersPlayed = [];

      // TODO: Debug
    }

    const maxIndex = newMembersInactive.length - 1;
    const random = randomIntFromInterval(0, maxIndex);

    newMembersPlaying = newMembersInactive.splice(random, 1);
    newMembersPlayed = [...newMembersPlayed, ...newMembersPlaying];

    // TODO: Debug

    this.setState({
      totalRound: Math.ceil(this.state.totalTimeSelected / sessionQuestionTimer),
      membersInactive: newMembersInactive,
      membersPlaying: newMembersPlaying,
      membersPlayed: newMembersPlayed,

      // Close All the Modal that possibly open
      isOpen_about: false,
      isOpen_embed: false,
      isOpen_team: false,
      isOpen_password: false
    });

    this.setCountDownTimer();
  };

  setCountDownTimer = () => {
    var duration = this.state.totalTimeSelected * 60;
    var timer = duration;
    var minutes;
    var seconds;

    var intervalId = setInterval(() => {
      minutes = Number.parseInt(timer / 60, 10);
      seconds = Number.parseInt(timer % 60, 10);
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;      
      
      --timer;

      if (timer < 0) {
        clearInterval(intervalId);
        this.setState({ currentTime: timer });
        this.isMaxTimer();
      }
    }, 1000);
  }

  onSubmitTeamAction = data => {
    this.setState({
      isOpen_question: false,
      currentRound: this.state.currentRound + 1
    });

    if (this.state.currentRound === this.state.totalRound) {
      this.setState({
        totalRound: this.state.currentRound + 1,
      });
    }

    if (data !== "") this.props.addTeamAction(data);
  };

  onOpen_about = () => {
    this.setState({ isOpen_about: true });
  };

  onOpen_instruction = () => {
    this.setState({ isOpen_instruction: true });
    this.childref.current.noTeamAction();
  };

  onClose_instruction = () => {
    this.setState({ isOpen_instruction: false });
  };

  onBlur = () => {
    this.setState({ isBlur_instruction: true });
  };

  onClose_team = () => {
    this.setState({ isOpen_team: false });
  };

  onClose_about = () => {
    this.setState({ isOpen_about: false });
  };

  onNext_instruction = () => {
    this.setState({ isNext_instruction: false });
  };

  onNext_addteam = () => {
    this.setState({
      isOpen_instruction: true,
      isActive: false
    });
    // this.setState({ isNext_instruction: false });
    this.childref.current.isTeamAction();
  };

  isMaxAlert = () => {
    this.childref.current.isMaxRound();
    this.childref.current.isMaxAlert();
  };

  isMaxChar = () => {
    this.childref.current.isMaxChar();
    this.childref.current.isMaxRound();
  };

  isMaxTimer = () => {
    this.childref.current.isMaxRound();
    this.childref.current.isMaxTimer();
  };

  isDisableFromModal = () => {
    // console.log(this.ModalQuestion.current);
  };

  onOpen_embed = () => {
    this.setState({ isOpen_embed: true });
  };

  onClose_embed = () => {
    this.setState({ isOpen_embed: false });
  };

  onOpen_editMember = () => {
    this.setState({
      isOpen_team: true
    });
  };

  onSet_Play = () => {
    this.setState({
      is_Play: "flex",
      is_Playing: true,
      isActive: true
    });
  };

  isValid = () => {
    this.setState({
      is_Valid: true
    });
  };

  onToggleCategory = () => {
    this.setState(prevState => ({
      categories_isOpen: !prevState.categories_isOpen
    }));
  };

  onSelectedPlayer = player => {
    this.setState({ selectedPlayer: player });
  };

  getColorByCategoryId = categoryId => {
    const cat = this.state.categories;

    const col = cat.filter(catId => catId.category_id === categoryId);

    if (col.length > 0) {
      return col[0];
    } else {
      return {
        color: "#81d742",
        text_color: "#000000"
      };
    }
  };

  onWheelSelect = async id => {
    const membersInactive = this.state.membersInactive;
    const membersPlayed = this.state.membersPlayed;
    const baseUrl = this.state.baseUrl;
    const excludeString = this.state.exclude.toString();
    const url = `${baseUrl}/wp-json/api/v1/the_question/cat/${id}?exclude=${excludeString}`;
    const questionUrl = window.themeObj.restURL + "/game/game-spin-the-wheel";
    const { color, text_color } = this.getColorByCategoryId(parseInt(id));
    const request = axios.post(questionUrl, {
      used_question: usedGlobal,
      category_id: parseInt(id),
      index: index
    });

    request.then(response => {
      var questData = response.data.data.rand_question;
      usedGlobal = questData.used;
      index = questData.index;

      const dataNotFound = {
        post_id: 9999,
        post_title: i18next.t("No question found"),
        post_content: i18next.t("No question found"),
        category_id: 9999,
        category_name: "-"
      };

      const data = questData ? questData.quest : dataNotFound;

      let newMembersPlaying;
      let newMembersPlayed;
      let newMembersInactive;

      if (membersInactive.length > 0) {
        newMembersInactive = [...membersInactive];
        newMembersPlayed = [...membersPlayed];
      } else {
        // Restart
        newMembersInactive = [...membersPlayed];
        newMembersPlayed = [];

        // TODO: Debug
      }

      const maxIndex = newMembersInactive.length - 1;
      const random = randomIntFromInterval(0, maxIndex);

      newMembersPlaying = newMembersInactive.splice(random, 1);
      newMembersPlayed = [...newMembersPlayed, ...newMembersPlaying];

      // TODO: Debug

      this.setState({
        membersInactive: newMembersInactive,
        membersPlaying: newMembersPlaying,
        membersPlayed: newMembersPlayed,
        // exclude: newExclude,
        question: data,
        isOpen_question: true,
        color: color,
        text_color: text_color,

        // Close All the Modal that possibly open
        isOpen_about: false,
        isOpen_embed: false,
        isOpen_team: false,
        isOpen_password: false
      });
    });
  };

  onCloseQuestion = () => {
    this.setState({
      isOpen_question: false
    });
  };

  onLogin = () => {
    /**
     * Why don't you combine the setState? to prevent unexpected double
     * scrollbar when Modal open (see Modal->useEffect), because it's async
     * task, with callback schema you can make sure the scrollbar update in the
     * right flow.
     *
     * Expected flow:
     * 1. Close Modal Password
     * 2. Update scrollbar (useEffect)
     * 3. Open Modal Team
     * 4. Update scrollbar (useEffect)
     */
    // set isOpen_team to false since it wont be needed
    const openTeam = this.setState({ isOpen_team: false });
    this.setState({ isOpen_password: false }, openTeam);
  };

  forceRerenderWheel = textStyle => {
    this.setState({
      wheelTextStyle: textStyle
    });
  };

  render() {
    const isRequredLogin = parseInt(window.themes.user) === 0 && parseInt(window.themes.required_login) === 1;
    if (isRequredLogin) {
      return <Navigate to="/login" />;
    }



    return (
      <UserProvider value={this.state}>
        <QueryClientProvider client={queryClient}>
          <DetectFontChange onChange={this.forceRerenderWheel} />
          <LayoutContent>
            {this.state.isShow_header && (
              <Header
                logo={this.state.logo}
                isWithEmbed={Boolean(parseInt(window.button_color.show_embed))}
                // Pass props for about button
                aboutButton={{
                  text: window.main_button.about_button
                    ? window.main_button.about_button
                    : i18next.t("About"),
                  background: window.themes?.secondary_use_single_color
                    ? window.themes.secondary_color
                    : `linear-gradient(${window.themes?.secondary_color_gradient?.direction
                    }, ${window.themes?.secondary_color_gradient
                      ?.gradient_colors[0]?.color
                    } 0%, ${window.themes?.secondary_color_gradient
                      ?.gradient_colors[1]?.color
                    } 100%)`,
                  onClick: this.onOpen_about
                }}
                // Pass props for edit team member button
                editMember={{
                  // text: window.button.button_team_member,
                  text: window.main_button.change_team_button
                    ? window.main_button.change_team_button
                    : i18next.t("Change Team"),
                  color: window.button_color.text_member_color,
                  background: window.themes?.secondary_use_single_color
                    ? window.themes.secondary_color
                    : `linear-gradient(${window.themes?.secondary_color_gradient?.direction
                    }, ${window.themes?.secondary_color_gradient
                      ?.gradient_colors[0]?.color
                    } 0%, ${window.themes?.secondary_color_gradient
                      ?.gradient_colors[1]?.color
                    } 100%)`,

                  onClick: this.onNext_addteam
                }}
                // Pass props for embed button
                embedButton={{
                  text: window.button.button_embed
                    ? window.button.button_embed
                    : i18next.t("Embed"),
                  color: window.button_color.text_embed_color,
                  background: window.themes?.secondary_use_single_color
                    ? window.themes.secondary_color
                    : `linear-gradient(${window.themes?.secondary_color_gradient?.direction
                    }, ${window.themes?.secondary_color_gradient
                      ?.gradient_colors[0]?.color
                    } 0%, ${window.themes?.secondary_color_gradient
                      ?.gradient_colors[1]?.color
                    } 100%)`,
                  onClick: this.onOpen_embed
                }}
                instructionButton={{
                  text: i18next.t("Instructions"),
                  color: window.button_color.text_embed_color,
                  background: window.themes?.secondary_use_single_color
                    ? window.themes.secondary_color
                    : `linear-gradient(${window.themes?.secondary_color_gradient?.direction
                    }, ${window.themes?.secondary_color_gradient
                      ?.gradient_colors[0]?.color
                    } 0%, ${window.themes?.secondary_color_gradient
                      ?.gradient_colors[1]?.color
                    } 100%)`,
                  onClick: this.onOpen_instruction
                }}
                finishSession={{
                  text: window.main_button.finish_session_button
                    ? window.main_button.finish_session_button
                    : i18next.t("Finish Session"),
                  color: "white",
                  background: window.themes?.primary_use_single_color
                    ? window.themes.primary_color
                    : `linear-gradient(${window.themes?.primary_color_gradient?.direction
                    }, ${window.themes?.primary_color_gradient
                      ?.gradient_colors[0]?.color
                    } 0%, ${window.themes?.primary_color_gradient
                      ?.gradient_colors[1]?.color
                    } 100%)`,
                  onClick: () => { }
                }}
                langSwitcher={window.themes.headerLangSwitcher}
                color={window.button_color.text_member_color}
                background={`linear-gradient(0deg, #086E5C 0%, #73DBA9 100%)`}
                display={this.state.is_Play}
                isPlaying={this.state.is_Playing}
                onOpenPassword={this.onOpenPassword}
                usePassword={this.state.isUse_password}
                login={this.props.login}
              />
            )}

            <Main
              categoryList={this.state.categories}
              members={this.state.members}
              onSelectMember={this.onSelectedPlayer}
              // Pass props for Wheel component, see: Wheel PropTypes
              wheel={{
                data: this.state.categories,
                isCustomLogo: window.button.custom_button_spinner,
                buttonText: window.button.button_spinner,
                buttonLogo: window.button.button_spinner_logo,
                buttonColor: window.button_color.text_spin_color,
                buttonBg: window.button_color.button_spin_color,
                onSelect: this.onWheelSelect,
                textStyle: this.state.wheelTextStyle
              }}
              isOpenQuestion={this.state.isOpen_question}
              currentRound={this.state.currentRound}
              currentTime={this.state.currentTime}
              totalRound={this.state.totalRound}
              isMaxAlert={this.isMaxAlert}
              result={this.state.selectedPlayer}
              isActive={this.state.isActive}
            />

            <Modal
              isOpen={this.state.isOpen_about}
              onClose={this.onClose_about}
            >
              <h3 className="modal-inner-title">{window.about.title}</h3>
              <div
                className="modal-inner-content"
                dangerouslySetInnerHTML={{ __html: window.about.text }}
              />
            </Modal>

            {/* <ModalEmbed
              baseUrl={this.state.baseUrl}
              widthPlaceholder={window.embed.width}
              heightPlaceholder={window.embed.height}
              // Pass props for generate button
              generateButton={{
                text: window.embed.generate,
                color: window.button_color.text_generate_color,
                background: window.button_color.button_generate_color,
              }}
              isOpen={this.state.isOpen_embed}
              onClose={this.onClose_embed}
            /> */}

            <ModalTeam
              image={window.welcome.logo_welcome}
              title={window.welcome.title_welcome}
              teamMembers={this.state.members}
              content={window.welcome.text_welcome}
              formTitle={window.member.choose}
              onClose={this.onClose_team}
              isOpen={this.state.isOpen_team}
              startButton={{
                text: window.member.start
              }}
              leaveButton={{
                text: i18next.t("Leave"),

                onClick: this.onClose_team,
                background: "linear-gradient(0deg, #D3341E 0%, #F17871 100%)"
              }}
              onStart={this.onStart}
              langSwitcher={window.welcome.lang_switcher}
              headerColor="white"
              headerBg={`linear-gradient(0deg, rgba(8, 110, 92, 1) 0%, rgba(115, 219, 169, 1) 100%)`}
            />

            <IntroductionScreen
              headerColor="white"
              buttonBackground={`linear-gradient(0deg, rgb(211, 161, 30) 0%, rgb(241, 205, 113) 100%)`}
              onClose={this.onClose_instruction}
              onSetPlay={this.onSet_Play}
              title={window.instruction.instruction_title}
              text={window.instruction.instruction_text}
              textInstruction={window.instruction.text_instruction}
              isOpen={this.state.isOpen_instruction}
              isBlur={this.state.isOpen_password ? true : false}
              teamMembers={this.state.members}
              langSwitcher={window.themes.headerLangSwitcher}
              onStart={this.onStart}
              instructionPageButton={{
                text: window.welcome.welcome_button_next
                  ? window.welcome.welcome_button_next
                  : i18next.t("Next"),
                background: window.themes?.primary_use_single_color
                  ? window.themes.primary_color
                  : `linear-gradient(${window.themes?.primary_color_gradient?.direction
                  }, ${window.themes?.primary_color_gradient?.gradient_colors[0]
                    ?.color
                  } 0%, ${window.themes?.primary_color_gradient?.gradient_colors[1]
                    ?.color
                  } 100%)`
              }}
              playGameButton={{
                text: window.setup_team.button_next
                  ? window.setup_team.button_next
                  : i18next.t("Play Game"),
                background: window.themes?.primary_use_single_color
                  ? window.themes.primary_color
                  : `linear-gradient(${window.themes?.primary_color_gradient?.direction
                  }, ${window.themes?.primary_color_gradient?.gradient_colors[0]
                    ?.color
                  } 0%, ${window.themes?.primary_color_gradient?.gradient_colors[1]
                    ?.color
                  } 100%)`,
                color: window.button_color.text_member_color
              }}
              next={this.state.isNext_instruction}
              wheel={{
                data: this.state.categories,

                isCustomLogo: window.button.custom_button_spinner,
                buttonText: window.button.button_spinner,
                buttonLogo: window.button.button_spinner_logo,
                buttonColor: window.button_color.text_spin_color,
                buttonBg: window.button_color.button_spin_color,
                onSelect: this.onWheelSelect,
                textStyle: this.state.wheelTextStyle
              }}
              categoryList={this.state.categories}
              members={this.state.members}
              nextInstructionButton={{
                text: i18next.t("Next"),
                onClick: this.onNext_instruction
              }}
              isDisable={this.isDisableFromModal}
              ref={this.childref}
              minimumSession={minimumSession}
              maximumSession={maximumSession}
              standardSessionTime={standardSessionTime}
              onChangeTimer={this.onChangeTimer}
              onOpenPassword={this.onOpenPassword}
              login={this.props.login}
              usePassword={this.state.isUse_password}
            />

            <ModalQuestion
              ref={this.ModalQuestion}
              image={this.state.question.icon_category}
              title={this.state.question.category_name}
              member={this.state.selectedPlayer}
              memberFor={window.question.for}
              question={this.state.question.post_content}
              color={this.state.color}
              text_color={this.state.text_color}
              headerColor="white"
              headerBg={`linear-gradient(0deg, rgba(8, 110, 92, 1) 0%, rgba(115, 219, 169, 1) 100%)`}
              onClose={this.onCloseQuestion}
              onSubmitTeamAction={this.onSubmitTeamAction}
              time={parseInt(window.timerDuration) * 60}
              isOpen={this.state.isOpen_question}
              isMaxChar={this.isMaxChar}
            />

            <ModalPassword
              title={window.button.login_text}
              invalidText={window.button.invalid_password}
              loginButton={{
                text: window.button.enter_password,
                color: window.button_color.text_login_color,
                background: window.themes.primary_color
              }}
              password={window.backend.choose_pw}
              onLogin={this.onLogin}
              isOpen={this.state.isOpen_password}
              isValid={this.isValid}
            />
            {/* <Notification /> */}
          </LayoutContent>
        </QueryClientProvider>
      </UserProvider>
    );
  }
}

export default Game;
